/* DIME Fall gift. Prices are enforced by Shopify discounts, never by this UI. */
(function (scope) {
  'use strict';
  const marker = 'fall-gift-v1';
  function managed(line) { return line.properties && line.properties._dime_fall_gift === marker; }
  function evaluate(cart, config) {
    const eligible = new Set(config.qualifyingProductIds.map(String));
    const giftProducts = new Set((config.giftProductIds || config.gifts.map(g => g.productId)).map(String));
    let units = 0;
    let otherUnits = 0;
    const distinct = new Set();
    for (const item of cart.items || []) {
      if (managed(item) || item.selling_plan_allocation) continue;
      const id = String(item.product_id);
      if (!eligible.has(id) || (config.excludeGiftProducts && giftProducts.has(id))) continue;
      const quantity = Math.max(0, Number(item.quantity) || 0);
      units += quantity;
      if (!giftProducts.has(id)) otherUnits += quantity;
      if (quantity) distinct.add(id);
    }
    const count = config.distinctProducts ? distinct.size : units;
    return { count, otherUnits, eligible: count >= 2 && otherUnits > 0, remaining: Math.max(otherUnits ? 0 : 1, 2 - count), managed: (cart.items || []).filter(managed) };
  }
  const rules = { evaluate, managed, marker };
  if (typeof module !== 'undefined' && module.exports) module.exports = rules;
  scope.DimeFallGiftRules = rules;
})(typeof window !== 'undefined' ? window : this);

(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  function start() {
    const root = document.querySelector('[data-dime-fall-gift]');
    const configNode = document.querySelector('#dime-fall-gift-config');
    if (!root || !configNode || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(configNode.textContent);
    config.giftProductIds = config.gifts.map(gift => gift.productId);
    config.gifts = config.gifts.map(gift => ({...gift, variants: gift.variants.filter(variant => variant.available)})).filter(gift => gift.variants.length);
    if (!config.enabled || !config.gifts.length) { root.hidden = true; return; }
    const rules = window.DimeFallGiftRules;
    const dialog = root.querySelector('dialog');
    const cards = root.querySelector('[data-gift-cards]');
    const status = root.querySelector('[data-gift-status]');
    const banner = root.querySelector('[data-gift-banner]');
    const launcher = root.querySelector('[data-gift-open]');
    const receipt = root.querySelector('[data-gift-receipt]');
    const route = config.root || '/';
    let cart = config.cart || {items:[]};
    let previewGift = null;
    let dismissed = false;
    let busy = false;
    let refreshTimer;
    let lastFingerprint = '';
    let previousFocus;
    let sequence = 0;
    const money = cents => new Intl.NumberFormat(config.locale || 'en-US', {style:'currency', currency:config.currency || 'USD'}).format(cents / 100);
    const text = (tag, value, className) => { const el = document.createElement(tag); el.textContent = value; if (className) el.className = className; return el; };
    async function request(path, body) {
      const response = await fetch(route + path, body ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'},cache:'no-store'});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
      return data;
    }
    function setBusy(value) {
      busy = value;
      dialog.setAttribute('aria-busy', String(value));
      root.querySelectorAll('[data-gift-add]').forEach(button => { button.disabled = value || button.dataset.soldOut === 'true'; });
      root.querySelectorAll('[data-gift-close]').forEach(button => { button.disabled = value; });
    }
    function close() { if (busy) return; dismissed = true; dialog.close(); }
    function open() {
      if (!rules.evaluate(cart,config).eligible || previewGift || rules.evaluate(cart,config).managed.length || busy) return;
      status.textContent = '';
      previousFocus = document.activeElement;
      if (!dialog.open) {
        const drawer = document.querySelector('cart-drawer.active');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        dialog.showModal();
      }
    }
    const bannerBox = root.querySelector('.dfg-banner');
    const bannerMount = document.createElement('div');
    bannerMount.setAttribute('data-dime-fall-gift', 'banner');
    function mountBanner() {
      if (config.demo) return;
      const slot = document.querySelector('cart-drawer .drawer__footer') || document.querySelector('#main-cart-footer');
      if (slot && bannerMount.parentElement !== slot) { bannerMount.appendChild(bannerBox); slot.prepend(bannerMount); }
      else bannerBox.hidden = true;
      if (slot) bannerBox.hidden = false;
    }
    function render() {
      mountBanner();
      const result = rules.evaluate(cart, config);
      if (!result.eligible) {
        previewGift = null;
        dismissed = false;
        if (dialog.open && !busy) dialog.close();
      }
      const selected = previewGift || result.managed[0];
      banner.textContent = result.eligible ? (selected ? 'Your Fall gift is selected.' : 'Your Fall gift is ready. Choose your favorite.') : (result.count >= 1 && !result.otherUnits) ? 'Add another Fall item (other than a beanie or bandana) to unlock your free gift.' : `Add ${result.remaining} more Fall ${result.remaining === 1 ? 'item' : 'items'} to unlock your free gift.`;
      launcher.hidden = !result.eligible || !!selected;
      receipt.hidden = !selected;
      receipt.replaceChildren();
      if (selected) {
        receipt.appendChild(text('strong', selected.product_title || selected.title));
        receipt.appendChild(text('span', config.previewOnly ? 'Selected in this preview. Your real cart is unchanged.' : 'One promotional gift per order.'));
        if (config.previewOnly) {
          const change = text('button','Change gift','dfg-text-button');
          change.type = 'button';
          change.addEventListener('click', () => { previewGift = null; dismissed = true; render(); open(); });
          receipt.appendChild(change);
        }
      }
      if (result.eligible && !selected && !dismissed && !busy) open();
    }
    async function removeManaged(items) {
      for (const item of items) await request('cart/change.js', {id:item.key, quantity:0});
    }
    async function refresh() {
      if (config.demo || busy) return;
      const ticket = ++sequence;
      try {
        const fresh = await request('cart.js');
        if (ticket !== sequence || busy) return;
        cart = fresh;
        const result = rules.evaluate(cart,config);
        if (!config.previewOnly && !result.eligible && result.managed.length) {
          setBusy(true);
          await removeManaged(result.managed);
          window.location.reload();
          return;
        }
        render();
      } catch (error) {
        status.textContent = 'Could not check your cart. Please refresh and try again.';
      }
    }
    async function addGift(gift, variant, button) {
      if (busy) return;
      setBusy(true);
      status.textContent = 'Checking your gift…';
      try {
        if (!config.demo) cart = await request('cart.js');
        const result = rules.evaluate(cart,config);
        if (!result.eligible) throw new Error('Your cart needs two qualifying Fall items first.');
        if (result.managed.length || previewGift) throw new Error('Your cart already has a Fall gift.');
        if (config.previewOnly) {
          previewGift = {product_title: gift.title + (variant.title === 'Default Title' ? '' : ` — ${variant.title}`)};
          setBusy(false);
          dialog.close();
          render();
          return;
        }
        // Activation requires a separate reviewed checkout integration. The draft
        // must never silently add a full-price gift while its rules are expired.
        if (!config.checkoutReady) throw new Error('This gift promotion is still a draft.');
        await request('cart/add.js', {items:[{id:variant.id,quantity:1,properties:{_dime_fall_gift:rules.marker}}]});
        const fresh = await request('cart.js');
        const after = rules.evaluate(fresh,config);
        const added = after.managed.find(line => String(line.variant_id) === String(variant.id));
        if (!after.eligible || !added || added.quantity !== 1 || added.final_line_price !== 0) {
          if (added) await removeManaged([added]);
          throw new Error('The gift discount could not be applied. The gift was not kept in your cart.');
        }
        window.location.reload();
      } catch (error) {
        status.textContent = error.message || 'Could not add your gift. Please try again.';
        setBusy(false);
        render();
      }
    }
    config.gifts.forEach(gift => {
      const article = document.createElement('article'); article.className = 'dfg-card';
      const image = document.createElement('img'); image.src = gift.image; image.alt = gift.title; image.width = 240; image.height = 220; image.loading = 'lazy';
      article.appendChild(image);
      article.appendChild(text('h3',gift.title));
      const prices = document.createElement('p'); prices.className = 'dfg-prices'; prices.appendChild(text('s',money(gift.price))); prices.appendChild(text('strong','FREE')); article.appendChild(prices);
      const available = gift.variants.filter(v => v.available);
      const select = document.createElement('select'); select.setAttribute('aria-label', `Choose ${gift.title} option`);
      gift.variants.forEach(variant => { const option = document.createElement('option'); option.value = String(variant.id); option.textContent = (variant.title === 'Default Title' ? 'One size' : variant.title) + (variant.available ? '' : ' — Sold out'); option.disabled = !variant.available; select.appendChild(option); });
      if (available.length) select.value = String(available[0].id);
      select.hidden = gift.variants.length === 1;
      article.appendChild(select);
      const button = text('button',available.length ? 'Choose this gift' : 'Sold out','dfg-select'); button.type = 'button'; button.dataset.giftAdd = ''; button.dataset.soldOut = String(!available.length); button.disabled = !available.length;
      button.addEventListener('click', () => { const variant = gift.variants.find(v => String(v.id) === select.value && v.available); if (variant) addGift(gift,variant,button); });
      article.appendChild(button); cards.appendChild(article);
    });
    root.querySelector('[data-draft-label]').hidden = !config.previewOnly;
    launcher.addEventListener('click', open);
    root.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click',close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } });
    dialog.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus(); });
    if (config.demo) {
      document.addEventListener('dime:demo-cart', event => { cart = event.detail; render(); });
      render();
    } else {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) new MutationObserver(() => {
        mountBanner();
        const items = drawer.querySelector('#CartDrawer-CartItems');
        const fingerprint = items ? items.textContent + Array.from(items.querySelectorAll('input')).map(input => input.value).join(',') : '';
        if (fingerprint === lastFingerprint) return;
        lastFingerprint = fingerprint;
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refresh, 650);
      }).observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
      const cartPage = document.querySelector('cart-items');
      if (cartPage) new MutationObserver(() => {
        clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 650);
      }).observe(cartPage, {childList:true,subtree:true});
      window.addEventListener('pageshow',refresh);
      window.addEventListener('focus',refresh);
      document.addEventListener('dime:cart-updated',refresh);
      refresh();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
